module.exports = __webpack_public_path__ + "static/media/tick.b2f12802.svg";